import React from 'react';

const tags = () => {
    return (
        <div style={{color:"#ffffff"}}>
            <h1>Videographers in Mumbai</h1>
            <h1>Video Shooters in Mumbai</h1>
            <h1>Graphic Designers in Mumbai</h1>
            <h1>Photographers in Mumbai</h1>
            <h1>Logo maker in Mumbai</h1>
            <h1>Mumbai Video Production</h1>
        </div>
    );
};

export default tags;


// WEBPACK FOOTER //
// ./src/pages/tags.js